import { deleteRequest, get, post } from './_defaults/fetch.js';

export const getAssistants = ({params, config}) => get('/assistants', {params, ...config});
export const getAssistant = ({id, params, config}) => get(`/assistants/${id}`, {params, ...config});
export const createAssistant = ({data, config}) => post('/assistants', data, config);
export const updateAssistant = ({id, data, config}) => post(`/assistants/${id}`, data, config);
export const deleteAssistant = ({id, config}) => post(`/assistants/${id}`, null, config);

export const createAssistantMcp = ({id, data, config}) => post(`/assistants/${id}/mcps`, data, config);
export const deleteAssistantMcp = ({id, mcpId, config}) => deleteRequest(`/assistants/${id}/mcps/${mcpId}`, null, config);

export const createAssistantArea = ({id, data, config}) => post(`/assistants/${id}/areas`, data, config);
export const deleteAssistantArea = ({id, areaId, config}) => deleteRequest(`/assistants/${id}/areas/${areaId}`, null, config);

export const createAssistantOffice = ({id, data, config}) => post(`/assistants/${id}/offices`, data, config);
export const deleteAssistantOffice = ({id, officeId, config}) => deleteRequest(`/assistants/${id}/offices/${officeId}`, null, config);

export const createAssistantTag = ({id, data, config}) => post(`/assistants/${id}/tags`, data, config);
export const deleteAssistantTag = ({id, tagId, config}) => deleteRequest(`/assistants/${id}/tags/${tagId}`, null, config);

export const createAssistantFolder = ({id, data, config}) => post(`/assistants/${id}/folders`, data, config);
export const deleteAssistantFolder = ({id, folderId, config}) => deleteRequest(`/assistants/${id}/folders/${folderId}`, null, config);